import React from 'react';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  variant?: 'default' | 'loading' | 'header';
  className?: string;
  showText?: boolean;
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'medium',
  variant = 'default',
  className = '',
  showText = false,
  onClick
}) => {
  const logoClasses = [
    'logo',
    `logo-${size}`,
    `logo-${variant}`,
    className
  ].filter(Boolean).join(' ');

  const LogoImage = (
    <img 
      src="/Logo.svg" 
      alt="Affordable Connects" 
      className={logoClasses}
      onClick={onClick}
    />
  );

  if (showText) {
    return (
      <div className={`logo-with-text logo-with-text-${size}`}>
        {LogoImage}
        <span className="logo-text">Affordable Connects</span>
      </div>
    );
  }

  return LogoImage;
};